import { updateProfile } from './states';

export const services = {
  updateProfile,
};
